import React, {createContext, useContext, useState} from "react";

const DownloadFileProgressContext = createContext();

export const DownloadProgressProvider = ({ children }) => {

    const [downloads, setDownloads] = useState([]);
    const [completedDownloads, setCompletedDownloads] = useState([]);

    const startDownload = (id, fileName) => {
        const download_id = `${id}-${Date.now()}`;
        setDownloads(prev => [...prev, { id: download_id, fileName, progress: 0, error: false }]);
        return download_id;
    };

    const batchStartDownload = (files) => {
        const downloadInfo = files.map(file => {
            const download_id = `${file.id}-${Date.now()}`; 
            setDownloads(prev => [...prev, { id: download_id, fileName: file.fileName, progress: 0, error: false }]);
            return {download_id: download_id, file: file};
        });
        return downloadInfo;
    }
    const updateProgress = (id, progress) => {
        setDownloads(prev => prev.map(d => d.id === id ? { ...d, progress } : d));
        if (progress === 100) {
            setCompletedDownloads(prev => [...prev, id]);
        }
    };

    const removeDownload = (id) => {
        setDownloads(prev => prev.filter(d => d.id !== id));
        setCompletedDownloads(prev => prev.filter(d => d !== id));
    };

    const clearDownloads = () => {
        setDownloads([]);
        setCompletedDownloads([]);
        
    }

    const updateErrorDownloads = (id) => {
        setDownloads(prev => prev.map(d => d.id === id ? { ...d, error: true} : d));
        setCompletedDownloads(prev => [...prev, id]);
    }
    return(
        <DownloadFileProgressContext.Provider value={{ downloads, clearDownloads, startDownload, batchStartDownload, updateProgress, removeDownload, completedDownloads, updateErrorDownloads }}>
            {children}
        </DownloadFileProgressContext.Provider>
    )
}

export const useDownloadFileProgress = () => useContext(DownloadFileProgressContext);
